<template>
    <div v-show='product.product'>
        <LockItInAddToCart class='spaced' :class="{'add-to-cart':product.typeid != '1'}" :item_quantity='item_quantity' :product='product' :in_stock='in_stock' @updatedCartListener='updatedCartListener' @addToCartListener="addedToCart" @removedFromCartListener="removedFromCart"/>
        <TextSeparator class='spaced' />
        <LockItInButtons :item_quantity='item_quantity' :variant_code='variant_code' :product='product' :in_stock='in_stock' @updatedCartListener='updatedCartListener' @addToCartListener="addedToCart"/>
    </div>
</template>
<script>
import AddToCart from '@/ecom/components/products/single_product/details/AddToCart.vue';
import ProductButtonsPlaceholders from '@/ecom/components/products/single_product/details/ProductButtonsPlaceholders.vue';
import TextSeparator from '@/ecom/components/separators/TextSeparator.vue';
import LockItInButtons from '@/ecom/components/products/single_product/details/LockItInButtons.vue';
import LockItInAddToCart from '@/ecom/components/products/single_product/details/LockItInAddToCart.vue';

export default {
    components: {AddToCart, ProductButtonsPlaceholders, TextSeparator, LockItInButtons, LockItInAddToCart},
    emits: ['updatedCartListener', 'addToCartListener', 'removedFromCartListener'],
    props: ['product', 'variant_code', 'in_stock'],
      data(){
        return{
            item_quantity: 2
        }
    },
    methods:{
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        addedToCart(product, quantity){
           this.item_quantity = quantity;
           this.$emit('addToCartListener', product, quantity);
        },
        removedFromCart(product, quantity){
           this.item_quantity = quantity;
           this.$emit('removedFromCartListener', product, quantity);
        }
    },
    watch: {
        'product': function() {
            if(this.product.locked_in){
                this.item_quantity = this.product.cart_quantity ?? 2;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.add-to-cart{
    margin-top: 30px;
}
.spaced{
    margin-bottom: 20px;
}
</style>